export const MODEL_V1 = "medilis.ai.V1(faster)";
export const MODEL_V2 = "medilis.ai.V2(deeper)";
export const MODEL_V3 = "medilis.ai.V3(thinking)";

const V2_COLUMN_ORDER = ["protocol_number", "contrast", "Tesla", "tesla"];

/** Doc: extractedText may have duplicate content. Truncate at first ", מתאריך," or leave as-is. */
export function getDisplayExtractedText(raw) {
  if (!raw || typeof raw !== "string") return "";
  const idx = raw.indexOf(", מתאריך,");
  if (idx !== -1) return raw.slice(0, idx).trim();
  return raw;
}

export function isV3Model(model) {
  return model === MODEL_V3;
}

export function pick(obj, ...keys) {
  if (!obj) return "";
  for (const k of keys) {
    const v = obj[k];
    if (v !== undefined && v !== null && String(v).trim() !== "") {
      return String(v).trim();
    }
  }
  return "";
}

export function getAdditionalFields(protocol) {
  return protocol?.additionalFields && typeof protocol.additionalFields === "object"
    ? protocol.additionalFields
    : {};
}

/** Ordered column keys for V2 table (protocol name is always first column). */
export function getV2TableColumnKeys(protocols) {
  const keys = new Set();
  for (const row of protocols || []) {
    Object.keys(getAdditionalFields(row)).forEach((k) => keys.add(k));
  }
  const ordered = [];
  for (const k of V2_COLUMN_ORDER) {
    if (keys.has(k)) {
      ordered.push(k);
      keys.delete(k);
    }
  }
  keys.forEach((k) => ordered.push(k));
  return ordered;
}

export function protocolRowsEqual(a, b) {
  if (!a || !b) return false;
  const af = getAdditionalFields(a);
  const bf = getAdditionalFields(b);
  const numA = pick(af, "protocol_number", "Protocol_Number", "number");
  const numB = pick(bf, "protocol_number", "Protocol_Number", "number");
  if (numA && numB) return numA === numB;
  return pick(a, "protocolName") === pick(b, "protocolName");
}

export function getEffectiveSelectedProtocol(result, manualSelection) {
  if (manualSelection) return manualSelection;
  if (result?.selectedProtocol) return result.selectedProtocol;
  const name = result?.selectedProtocolName;
  if (!name) return null;
  const list = result?.recommendedProtocols;
  if (Array.isArray(list)) {
    const match = list.find(
      (row) => pick(row, "protocolName") === String(name).trim()
    );
    if (match) return match;
  }
  return { protocolName: name };
}

export function hasAutoSelectedProtocol(result) {
  return Boolean(result?.selectedProtocol || result?.selectedProtocolName);
}

export function parseHintsToTags(value) {
  if (value == null || value === "") return [];
  if (Array.isArray(value)) {
    return value.map((x) => String(x).trim()).filter(Boolean);
  }
  return String(value)
    .split(/[|,]/)
    .map((s) => s.trim())
    .filter(Boolean);
}

export function getHintsFromProtocol(protocol) {
  const af = getAdditionalFields(protocol);
  const raw =
    af.hints ??
    af.keywords ??
    af.Hints ??
    af.Keywords ??
    protocol?.hints ??
    protocol?.keywords;
  return parseHintsToTags(raw);
}

export function formatColumnHeader(key, t) {
  const map = {
    protocol_number: t("colNumber"),
    contrast: t("colContrast"),
    Tesla: t("colTesla"),
    tesla: t("colTesla"),
  };
  return map[key] || key.replace(/_/g, " ");
}

export function isContrastYes(value) {
  const v = String(value ?? "")
    .trim()
    .toLowerCase();
  return v === "yes" || v === "true" || v === "1";
}

export function protocolDisplayTitle(protocol) {
  const af = getAdditionalFields(protocol);
  const num = pick(af, "protocol_number", "Protocol_Number");
  const name = pick(protocol, "protocolName", "ProtocolName");
  if (num && name) return `${num}: ${name}`;
  return name || num || "—";
}
